import styled from 'styled-components'

export const QuestionsDetailsSkeletonContainer = styled.div`
  div {
    padding: 0 !important;
  }
`
